import { createContext, use } from 'react';
import type { OverlayCloseReason, OverlayVariant } from './overlay.types';

/** What an overlay shell shares with its header, footer and body. */
export interface OverlayContextValue {
  variant: OverlayVariant;
  titleId: string;
  subtitleId: string;
  busy: boolean;
  /** Asks the shell to close; it applies the busy / dismissible / confirmClose rules. */
  requestClose: (reason: OverlayCloseReason) => void;
}

export const OverlayContext = createContext<OverlayContextValue | null>(null);

/** The enclosing overlay shell, or null when used outside one. */
export const useOverlay = () => use(OverlayContext);
